module.exports = __webpack_public_path__ + "img/btn_menu_nzz.21a5f0f9.png";